import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { ContentContainer, CourseCard2 } from 'components';
import { Pagination } from '@mui/material';
import moodleAxios from '../../services/moodle/moodleApi';
import { useUserContext } from 'UserProvider';
import { token } from 'utils/baseURLs';

const ReportPage = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [coursePerPage] = useState(10);
  const [datalength, setDatalength] = useState(false);
  const { userContext } = useUserContext();

  useEffect(() => {
    const fetchCourses = async () => {
      const userId = userContext?.userData?.id || localStorage.getItem('userid');

      if (!userId) {
        console.error('User context and session storage userId are not available');
        return;
      }

      setLoading(true);
      try {
        const res = await moodleAxios.post(
          `/webservice/rest/server.php?wstoken=${token}&wsfunction=mod_kb_get_user_kb_courses&moodlewsrestformat=json&userid=${userId}`
        );
        if (res.data) {
          setDatalength(true);
          setCourses(res.data);
        }
      } catch (error) {
        console.error('Error fetching courses:', error);
      } finally {
        setLoading(false);
      }
    };

    const activityInstance = sessionStorage.getItem('activityInstance');
    const usrtoken = sessionStorage.getItem('token');

    if (activityInstance || usrtoken) {
      fetchCourses();
    }
  }, [userContext]);

  const indexOfLastPage = currentPage * coursePerPage;
  const indexOfFirstPage = indexOfLastPage - coursePerPage;
  const currentCourses = courses.length > 0 ? courses.slice(indexOfFirstPage, indexOfLastPage) : [];

  const paginate = e => {
    setCurrentPage(Number(e));
    window.scrollTo(0, 0);
  };

  return (
    <ContentContainer title="Reports">
      {/* Courses Section */}
      {loading ? (
        <div>
          <ReactLoading type={'spin'} color={'grey'} />
        </div>
      ) : (
        <>
          {!datalength && <h4 style={{ textAlign: 'center', color: 'red' }}>No data is present</h4>}
          {datalength &&
            courses.length > 0 &&
            currentCourses.map((course, i) => (
              <CourseCard2
                id={course.id}
                key={i}
                session={course.fullname ? course.fullname : course.name}
                activity={''}
              />
            ))}

          {coursePerPage >= courses.length ? null : (
            <Pagination
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '20px'
              }}
              page={currentPage}
              count={courses.length > 0 ? Math.ceil(courses.length / coursePerPage) : 0}
              onClick={e => paginate(e.target.textContent)}
              color="secondary"
            />
          )}
        </>
      )}
    </ContentContainer>
  );
};

export default ReportPage;
